import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface INoteTypeModel extends IModel {
  noteTypeId: number;
  name: string;
}

export class NoteTypeModel
  extends Model
  implements ModelRecord<INoteTypeModel>
{
  noteTypeId: number;
  name: string;

  constructor(params?: Partial<INoteTypeModel>) {
    super(params);
    this.noteTypeId = defaultTo(params?.noteTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
